import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WarmMinimalist() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}